import React from "react";
import { FaCheck } from "react-icons/fa6";

const recommendations = [
  "Choose a policy without high compulsory deductibles, as this can increase your out-of-pocket expenses during a claim.",
  <>
    Make sure the <span className="font-semibold text-black">Insured Declared Value (IDV)</span> of your vehicle is correctly set to receive a fair claim amount.
  </>,
  "Pay premiums regularly and on time.",
  "Renew your motor insurance policy on time to avoid coverage gaps and to retain your No Claim Bonus (NCB).",
  "Inform the insurance company immediately in case of an accident and avoid starting repairs before inspection.",
  <>
    For a detailed consultation with our experts, you can email us at <span className="font-semibold text-black">polifyx@insurancesamadhan.com</span>.
  </>
];
export const MotorRecommendation: React.FC = () => {
  return (
    <div className="border bg-white border-gray-200 rounded-xl shadow-sm overflow-hidden my-6">
      <div className="bg-[#F1FCF9] text-center py-3">
        <h2 className="text-base md:text-xl font-extrabold">Our Recommendations</h2>
      </div>
      <ul className="divide-y divide-gray-200">
        {recommendations.map((rec, index) => (
          <li key={index} className="flex items-center gap-3 px-2 py-2 md:px-4 md:gap-4 text-base">
            <div className="min-w-[20px] mt-1.5 sm:mt-0">
              <FaCheck className="text-[#2F9D7F]" />
            </div>
            <p className="text-gray-700 leading-relaxed text-sm font-medium">{rec}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};
